import { render } from "./ManageResult.vue?vue&type=template&id=50840698"
import script from "./ManageResult.vue?vue&type=script&lang=js"
export * from "./ManageResult.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__